const baseURL = process.env.REACT_APP_API_URL;

export const urlAttribution = `${baseURL}/attribution`
export const urlUsers = `${baseURL}/user`
export const urlClient = `${baseURL}/client`
export const urlRollingColumns = `${baseURL}/rollingcolumns`
export const urlUniverse = `${baseURL}/universe`
export const urlTab = `${baseURL}/tab`
export const urlAssetGrowthCategories = `${baseURL}/assetgrowthcategories`
export const urlInvestmentGrowth = `${baseURL}/investmentgrowth`
export const urlTeamAverages = `${baseURL}/teamaverages`
export const urlPicklist = `${baseURL}/picklist`
export const urlEvent = `${baseURL}/event`
export const urlMatchData = `${baseURL}/matchdata`
